import React, { useMemo } from "react";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormViewAsyn, formDetailsAsync, setviewForms } from "../../../app/customFormSlice";
import styles from "./characteristicCustomForm.module.scss";
import { Button } from "../../primary";
import { useParams } from "react-router-dom";
import { signLockAsync } from "../../../app/patientSlice";
import { signedLockedAccess } from "../../../utils";
import { Confirmation } from "../../secondary/Confirmation/confirmation";
import warning from "../../../static/images/icon-check-danger.png";
import { EditIcon } from "./CharacteristicCustomForm/editIcon";
import { ViewCustomForm } from "./CharacteristicCustomForm/viewCustomForm";
import { EditCustomForm } from "./CharacteristicCustomForm/editCustomForm";
import Loader from '../../../static/images/spinner.svg';

export function CharacteristicCustomForm({
  index,
  name,
  formId,
  queryParam,
  updateDone,
  selectedIndex,
  hideIt,
  assessmentDetails,
  isCompleted,
  characteristicTabsData,
}) {
  // Edit state
  const [editable, setEditable] = useState(false);
  const [formChangesConfirm, setFormChangesConfirm] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [clickCancel, setClickCancel] = useState(false);
  const confirmationClose = () => {
    setConfirmationModal(false);
    setClickCancel(false);
  };
  const yesConfirmationModalClick = () => {
    handleYes();
    setConfirmationModal(false);
    setEditable(false);
    setFormChangesConfirm(false);
    setClickCancel(false);
  };
  useEffect(() => {
    if (editable) {
      if (formChangesConfirm && clickCancel) {
        setConfirmationModal(true);
      } else if (clickCancel && formChangesConfirm === false) {
        setClickCancel(false);
        setConfirmationModal(false);
        setEditable(false);
      }
    }
  }, [formChangesConfirm, clickCancel, editable]);

  const payload = {
    id: formId,
    queryParam: queryParam,
  };

  const dispatch = useDispatch();

  // get forms
  const forms = useSelector((state) => state.forms.formDetailsData);
  const viewForm = useSelector((state) => state.forms.viewForms);
  const showViewForm = useSelector((state) => state.forms.viewForms);
  const viewFormLoading = useSelector((state) => state.forms.viewFormLoading);

  const formBuilder = useMemo(() => {
    if (!forms?.formBuilderInfo?.length) return [];

    return [...forms.formBuilderInfo].sort((a, b) => a.order - b.order);
  }, [forms?.formBuilderInfo]);

  let [getForm, setgetForm] = useState(viewForm);
  const [customFormBuilder, setcustomFormBuilder] = useState(formBuilder);

  useEffect(() => {
    if (!formBuilder.length || !viewForm?.formdata?.length) {
      setgetForm(viewForm);
      return
    };
    const _viewForm = viewForm?.formdata
      ?.map((item, index) => {
        let getQueOption = formBuilder?.find((f) => f.id === item.id);
        let order = getQueOption?.order ?? index;
        return { ...item, order };
      })
      .sort((a, b) => {
        return a.order - b.order;
      });
    setgetForm({ formdata: _viewForm });
    // showViewForm && setshowForm(showViewForm);
    setcustomFormBuilder(formBuilder);
  }, [formBuilder, showViewForm, viewForm]);

  useEffect(() => {
    dispatch(setviewForms({}));
    dispatch(getFormViewAsyn(payload));
    dispatch(formDetailsAsync(formId));
  }, [formId]);

  useEffect(() => {
    if (showViewForm && showViewForm?.formdata && showViewForm?.formdata?.length > 0) {
      setEditable(false);
    } else {
      setEditable(true);
    }
  }, [showViewForm]);

  let upDateStatus = useSelector((state) => state.forms.upDateSaveForm);

  // Call sign and lock on saving the form
  const { patientId, assessmentId } = useParams();
  useEffect(() => {
    if (upDateStatus.status === "success") {
      const signLockPayload = {
        patientId,
        assessmentId,
        type: "signlockactions",
      };
      dispatch(signLockAsync(signLockPayload));
    }
  }, [upDateStatus]);

  const [closeWarning, setCloseWarning] = useState(false);
  const handleYes = () => {
    setgetForm(viewForm);
    setCloseWarning(false);
    setEditable(false);
  };
  /* No fn */
  const handleNo = () => {
    setCloseWarning(false);
  };

  return (
    <>
      {confirmationModal && (
        <Confirmation onClose={() => confirmationClose()} title={" "}>
          <div className="text-center pr-5 pl-5">
            <p>
              <img src={warning} alt="warnning-icon" />
            </p>
            <p className="pb-3">All progress in this section will be lost. Are you sure want to cancel?</p>
            <div className="mb-2">
              <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${styles.yes_btn}` }} onClick={() => yesConfirmationModalClick()} />
              <Button id="closeId" value="No" classes={{ className: `btn ml-2 pb-2 pt-2 ${styles.no_btn}` }} onClick={() => confirmationClose()} />
            </div>
          </div>
        </Confirmation>
      )}

      {signedLockedAccess(assessmentDetails?.assessmentStage) && hideIt && <EditIcon editable={editable} setEditable={setEditable} />}
      {!viewFormLoading && <div className={`col-md-12 ${styles.single_product_block}`}>
        <div className="row">
          <div className={`p-0 ${styles.patient_content}`}>
            {!editable ? (
              <ViewCustomForm getForm={getForm} customFormBuilder={customFormBuilder} />
            ) : (
              <EditCustomForm
                index={index}
                name={name}
                formId={formId}
                queryParam={queryParam}
                updateDone={updateDone}
                selectedIndex={selectedIndex}
                hideIt={hideIt}
                assessmentDetails={assessmentDetails}
                isCompleted={isCompleted}
                customFormBuilder={customFormBuilder}
                getForm={getForm}
                setgetForm={setgetForm}
                closeWarning={closeWarning}
                handleYes={handleYes}
                handleNo={handleNo}
                characteristicTabsData={characteristicTabsData}
                setFormChangesConfirm={setFormChangesConfirm}
                setClickCancel={setClickCancel}
                setcustomFormBuilder={setcustomFormBuilder}
              />
            )}
          </div>
        </div>
      </div>}
      {viewFormLoading && (
        <div className={`loader`}>
          <img src={Loader} alt="loading" />
        </div>
      )}
    </>
  );
}
